<template>
  <el-dialog title="移除提示确认" size="small" :visible.sync="visible">
    <el-descriptions :column="1" border :label-style="{width: '100px'}">
      <el-descriptions-item label="房产数量">
        <span v-if="houseInfo.next_house_arr&&houseInfo.next_house_arr.length>0">{{ houseInfo.next_house_arr.length }}</span>
        <div class="next-house-tags" v-if="houseInfo.next_house_arr&&houseInfo.next_house_arr.length>0">
          <div v-for="(houseInfo,index) in houseInfo.next_house_arr" :key="index">
            <el-tag type="success" >{{ houseInfo }}</el-tag>
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="用户关系">{{ houseInfo.customer_count }} 条</el-descriptions-item>
      <el-descriptions-item label="账单数量">{{ houseInfo.order_count }} 个</el-descriptions-item>
      <el-descriptions-item label="仪表数量">{{ houseInfo.meter_count }} 个</el-descriptions-item>
      <el-descriptions-item label="分摊对象数量">{{ houseInfo.meter_object_count }} 个</el-descriptions-item>

      <el-descriptions-item label="移除条件">
        <div>
          移除前提：房产、用户关系、账单、仪表、分摊对象均为空，方可移除该房产。否则，请先清理相关数据后再尝试移除。
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: right; margin-top: 20px;">
      <el-button type="primary" @click="hide">关闭</el-button>
      <el-button type="primary" @click="confirmRemove">确认移除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Http from "../../../common/Http";

export default {
  name: "HouseRelatedInfo",
  data() {
    return {
      visible: false,
      where: {},
      houseInfo: {
        next_house_arr: [],
        customer_count: 0,
        order_count: 0,
        meter_count: 0,
        meter_object_count: 0
      },
      callback: null,
    };
  },
  methods: {
    show(where,callback) {
      this.visible = true;
      this.where = where;
      this.getHouseInfo();
      this.callback = callback;
    },
    hide() {
      this.visible = false;
      this.callback = null;
      this.houseInfo = {};
      this.where = {};
    },
    getHouseInfo(where) {
      const that = this;
      Http.post("HouseTree/getHouseInfo",{
        project_id:that.where.erp_pindex_id||89,
        house_id:that.where.house_id,
      },ret=>{
        if(ret.code){
          that.houseInfo = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    confirmRemove() {
      const that = this;
      if(that.houseInfo.next_house_arr&&that.houseInfo.next_house_arr.length>0){
        that.$message.error("该房产下还有房产，请先清理相关数据后再尝试移除。");
        return;
      }
      if(that.houseInfo.customer_count>0){
        that.$message.error("该房产下还有用户关系，请先清理相关数据后再尝试移除。");
        return;
      }
      if(that.houseInfo.order_count>0){
        that.$message.error("该房产下还有账单，请先清理相关数据后再尝试移除。");
        return;
      }
      if(that.houseInfo.meter_count>0){
        that.$message.error("该房产下还有仪表，请先清理相关数据后再尝试移除。");
        return;
      }
      if(that.houseInfo.meter_object_count>0){
        that.$message.error("该房产下还有分摊对象，请先清理相关数据后再尝试移除。");
        return;
      }
      Http.post("HouseTree/removeHouseTree",{
        project_id:that.where.erp_pindex_id||89,
        house_id:that.where.house_id,
      },ret=>{
        if(ret.code){
          typeof that.callback === "function" && that.callback(that.where.house_id);
          that.hide();
        }else {
          that.$message.error(ret.msg);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.next-house-tags{
  height: 200px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseRelatedInfo.vue